<gen-button [type]="'quite'"
        [fullSize]="true"
        (click)="redirectTo()"
        [ngClass]="{'active': config.isActive}">
    <ng-container contentProjectedData *ngIf="showCount  && (countValue$ | async); then showCountBlock; else defaultTemplate" >
    </ng-container>
</gen-button>

<ng-template #showCountBlock>

    <div class="events-icon-wrapper">
        <i class="button__icon {{config?.iconName}}" *ngIf="config?.iconName"></i>
        <sup class="event-icon event-not-approved"> ? </sup>
    </div>
    <span class="button__text" [innerHtml]="config?.name | stringTranslate"></span>
    <div class="event-count"> ({{countValue$ | async}}) </div>
</ng-template>

<ng-template #defaultTemplate>
    <i class="button__icon {{config?.iconName}}" *ngIf="config?.iconName"></i>
    <span class="button__text" [innerHtml]="config?.name | stringTranslate"></span>
</ng-template>